var _excluded = ["columns", "items", "itemCount", "offset", "onViewportChange", "onScroll", "renderCell", "getTextValue", "aria-label"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { useMemo } from 'react';
import { TableViewNormalized } from "./TableViewNormalized.js";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A resizable Spectrum table for small, potentially windowed data sets.
 * The supplied items are placed at their absolute offset among itemCount rows.
 */
export function TableView(_ref) {
  var columns = _ref.columns,
    items = _ref.items,
    itemCount = _ref.itemCount,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? 0 : _ref$offset,
    onViewportChange = _ref.onViewportChange,
    onScroll = _ref.onScroll,
    renderCell = _ref.renderCell,
    getTextValue = _ref.getTextValue,
    _ref$ariaLabel = _ref['aria-label'],
    ariaLabel = _ref$ariaLabel === void 0 ? 'Table' : _ref$ariaLabel,
    spectrumProps = _objectWithoutProperties(_ref, _excluded);
  var rowCount = Math.max(0, itemCount);
  var tableItems = useMemo(() => {
    var windowedItems = Array.from({
      length: rowCount
    }, (_, key) => ({
      key
    }));
    items.forEach((item, index) => {
      var key = offset + index;
      if (key >= 0 && key < windowedItems.length) {
        windowedItems[key] = {
          key,
          item
        };
      }
    });
    return windowedItems;
  }, [items, offset, rowCount]);
  return /*#__PURE__*/_jsx(TableViewNormalized, _objectSpread({
    "aria-label": ariaLabel,
    columns: columns,
    normalizedItems: tableItems,
    onViewportChange: onViewportChange,
    onScroll: onScroll,
    renderCell: renderCell,
    getTextValue: getTextValue
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, spectrumProps));
}
export default TableView;
//# sourceMappingURL=TableView.js.map